import {
  Box,
  Button,
  Typography,
  Stack,
  CircularProgress,
  Chip,
  Tabs,
  styled,
  Tab,
  Grid,
  Alert,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AddIcon from "@mui/icons-material/Add";
import FullTaskLayout from "../../../Layouts/FullTask";
import FullTaskTopbar from "../../../Components/Topbars/FullTaskTopbar";
import FullTaskSplit from "../../../Layouts/FullTask/FullTaskSplit";

import {
  AclMatch,
  GetFileSize,
  OpenLinkInNewTab,
  UserHasAcl,
  UserHasAcls,
  UserHasLicence,
  AssetTypeAlphaColor,
} from "../../../Utils/helpers";
import { useNavigate, useParams } from "react-router";

import { ObjectType } from "../../../Core/Api/Types/object-type";
import { routePaths } from "../../../Router/router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  AdminAssetSinglePendingUploadDetails,
  DbAssetObjectInfos,
} from "../../../Core/Api/Types/db-asset-object-infos";
import {
  assetService,
  cacheService,
  mediaService,
  thumbnailService,
  workflowService,
} from "../../../Core/Api/services";
import AssetClassChip from "../../../Components/Misc/Chips/AssetChip/asset-class-chip";
import { ObjectClass } from "../../../Core/Api/Types/object-class";
import GlobalConst from "../../../Core/Utils/Constants/globals";
import { AclTypes } from "../../../Core/Api/Types/acl-types";
import ReactPlayerWrapper from "../../../Components/MediaPlayer/ReactPlayerWrapper/player-wrapper";
import { DbAssetMarkerInfos } from "../../../Core/Api/Types/db-asset-marker-infos";
import { MapQCMarkerData } from "../../../Components/Cards/QCMarkerCard/qc-marker-card";
import { FrameToTimecode } from "../../../Utils/Timecode/ReactPlayer";
import { useDispatch } from "react-redux";
import { GetMarkers, SetPlayerInput } from "../../../Redux/Reducers/redux-slice-react-player";
import AssetTypeChip from "../../../Components/Misc/Chips/AssetChip/asset-type-chip";
import LinkIcon from "@mui/icons-material/Link";
import DownloadIcon from "@mui/icons-material/Download";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { GetMetadataByTagName } from "../../../Core/Utils/asset-object-utils";
import PanelTabContent from "../../../Components/Panels/PanelTabContent/panel-tab-content";
import MarkersTable from "../../../Components/Table/MarkersTable/markers-table";
import { useHotkeys } from "react-hotkeys-hook";
import { ModalContext } from "../../../Components/Modals";
import ModalMarkerCreateOrEdit, {
  ModalMarkerCreateOrEditProps,
} from "../../../Components/Modals/ModalMarkers/modal-marker-create-or-edit";
import { useSelector } from "react-redux";
import { FamilyMarkerDto, TypeMarkerDto } from "../../../Components/Panels/MarkerPanel/marker-and-clip-panel";
import { produce } from "immer";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { ObjectStatus } from "../../../Core/Api/Types/object-status";
import MetadataEditor from "../../../Components/MetadataEditor/metadata-editor";
import { MetadataViewType } from "../../../Core/Api/Types/metadata-view-type";
import { IDbBaseMetadataValueInfos } from "../../../Core/Api/Types/i-db-base-metadata-value-infos";
import { UpdateMetadataFieldsRequest } from "../../../Core/Api/Types/update-metadata-fields-request";
import { DbFileInfos } from "../../../Core/Api/Types/db-file-infos";
import MediaCard from "../../../Components/Cards/MediaCard/media-card";
import moment from "moment";
import ModalCompleteUserTask, {
  ModalCompleteUserTaskElementProps,
} from "../../../Components/Modals/ModalCompleteUserTask/modal-complete-user-task";
import AudioTracksExcel from "../../../Components/AudioTracks/audio-tracks-excel";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ListIcon from "@mui/icons-material/List";
import { DbMarkerSeverity } from "../../../Core/Api/Types/db-marker-severity";
import { DbMarkerCategory } from "../../../Core/Api/Types/db-marker-category";
import ImageIcon from "@mui/icons-material/Image";
import { DbMarkerLevel } from "../../../Core/Api/Types/db-marker-level";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import FormSection from "../../../Components/Forms/FormSection/form-section";
import SwitchPlayerWrapper from "./switch-player-wrapper";
import { Licences } from "../../../Core/Api/Types/licences";
import ModalMarkerRevisionReview, {
  ModalMarkerRevisionReviewProps,
} from "../../../Components/Modals/ModalMarkers/modal-marker-revision-review";
import { AddOrUpdateMarkersByObjectIdRequest } from "../../../Core/Api/Types/add-or-update-markers-by-object-id-request";
import { DbMarkerStatus } from "../../../Core/Api/Types/db-marker-status";
import { PlatformMode } from "../../../Core/Api/Types/platform-mode";
import AssetHeroAdamCard from "../../../Components/Assets/AssetHeroAdamCard/asset-hero-adam-card";
import TableSkeleton from "../../../Components/Table/TableSkeleton";
import ModalCheckUpdateMetadataFields, {
  ModalCheckUpdateMetadataFieldsElementProps,
} from "../../../Components/Modals/ModalCheckUpdateMetadataFields/modal-check-update-metadata-fields";
import AudioTracksList from "../../../Components/AudioTracks/audio-tracks-list";
import ModalPreviewBatonPdf, {
  ModalDocumentPreviewElementProps,
} from "../../../Components/Modals/ModalPreview/modal-document-baton-pdf";
import {
  SetActiveTimeline,
  SetFilteredTimelineMarkers,
  SetTimelineMarkers,
  TimelineType,
} from "../../../Redux/Reducers/redux-slice-timeline";
import { SetPlayerHeight, SetPlayerResponsive } from "../../../Redux/Reducers/redux-slice-layout";
import { useTranslation } from "react-i18next";

export type QcToolProps = {};

const QcTool: React.FC<QcToolProps> = (props) => {
  const { t } = useTranslation();
  const {} = props;
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };
  const enqueueCustomSnackbar = useCustomSnackbar();

  const [obj, setObject] = useState<DbAssetObjectInfos>();
  const [isAdamTrailer, setIsAdamTrailer] = useState<boolean>(false);
  const [refVideoAssetId, setRefVideoAssetId] = useState<number>();
  const [markers, setMarkers] = useState<DbAssetMarkerInfos[]>([]);
  const [checkedMarkers, setCheckedMarkers] = useState<DbAssetMarkerInfos[]>([]);
  const [lastMarker, setLastMarker] = useState<DbAssetMarkerInfos>();
  const [markerFamilies, setMarkerFamilies] = useState<FamilyMarkerDto[]>([]);
  const [markerTypes, setMarkerTypes] = useState<TypeMarkerDto[]>([]);
  const [frameDuration, SetFrameDuration] = React.useState<number>(0);
  const [frameRate, setFrameRate] = React.useState<number>(0);
  const [objectType, setObjectType] = useState<ObjectType>(ObjectType.Video);
  const [isLoadingObj, setIsLoadingObj] = useState(true);
  const [isLoadingMarkers, setIsLoadingMarkers] = useState(true);
  const [objectFullName, setObjectFullName] = useState(GlobalConst.LOADING_TEXT);
  const [qcData, setQcData] = useState<AdminAssetSinglePendingUploadDetails | undefined>();
  const [files, setFiles] = useState<DbFileInfos[]>([]);
  const [tabValue, setTabValue] = React.useState(0);
  const [filterMarkerSeverity, setFilterMarkerSeverity] = React.useState<DbMarkerSeverity>();
  const [filterMarkerLevel, setFilterMarkerLevel] = React.useState<DbMarkerLevel>();
  const [filterMarkerCategory, setFilterMarkerCategory] = React.useState<DbMarkerCategory>();
  const [filterMarkerFamilies, setFilterMarkerFamilies] = React.useState<string[]>([]);
  const [linkedToSwitch, setLinkedToSwitch] = useState(false);
  const [switchData, setSwitchData] = useState<any>({});

  // Metadata
  const [metadataUpdates, setMetadataUpdates] = useState<IDbBaseMetadataValueInfos[]>([]);
  const [metadataUpdatesValid, setMetadataUpdatesValid] = useState(false);

  const markersInout = useSelector(GetMarkers);

  const getMarkerWIthTC = (mrk: DbAssetMarkerInfos, frameRate: number, frameDuration: number) => {
    return {
      ...mrk,
      timecodeIn: FrameToTimecode(mrk.frameIn === null ? 0 : mrk.frameIn, frameRate ?? mrk!.frameRate),
      timecodeOut: FrameToTimecode(mrk.frameOut === null ? frameDuration : mrk.frameOut, frameRate ?? mrk!.frameRate),
    };
  };

  const id: number = parseInt(params.id ?? "-1");
  const platformMode = cacheService.GetPlatformMode();

  // Hotkeys
  useHotkeys(
    "ctrl+m",
    () => {
      if (!UserHasAcl(AclTypes.aclMarkerCreateOrUpdate)) return;

      console.debug("hotkey:: open marker modal");
      openNewMarkerModal();
    },
    [id, obj, markersInout, markerFamilies, markerTypes, lastMarker]
  );

  const handleSendReviewNotif = () => {
    openModal &&
      openModal<ModalMarkerRevisionReviewProps>(ModalMarkerRevisionReview, {
        objectId: id,
        markers: checkedMarkers,
        onConfirm: () => {
          handleConfirmRevision();
        },
        closeModal: () => {},
      });
  };

  const openNewMarkerModal = useCallback(() => {
    openModal &&
      openModal<ModalMarkerCreateOrEditProps>(ModalMarkerCreateOrEdit, {
        mode: "create",
        objectId: id,
        frameRate: obj ? GetMetadataByTagName(obj, "techFrameRate")?.value ?? 0 : 0,
        tcIn: undefined, //markersInout.markIn.markTimecodeFile,
        tcOut: undefined, // empty by default (markersInout.markOut.markTimecodeFile),
        tcFileIn: GetMetadataByTagName(obj!, "tcIn")?.value,
        families: markerFamilies,
        types: markerTypes,
        marker: lastMarker,
        onClose: (marker: DbAssetMarkerInfos) => {
          setLastMarker(marker);
          setMarkers(
            produce((draft) => {
              draft.unshift(marker);
            })
          );
        },
        closeModal: () => {},
      });
  }, [id, obj, markersInout, markerFamilies, markerTypes, lastMarker]);

  //Player capabilities
  useEffect(() => {
    dispatch(SetTimelineMarkers(MapQCMarkerData(markers, frameDuration).filter((x) => x.timecodes.out.isSet)));
    dispatch(SetFilteredTimelineMarkers(MapQCMarkerData(markers, frameDuration).filter((x) => x.timecodes.out.isSet)));
    dispatch(SetActiveTimeline(TimelineType.Markers));
  }, [markers, frameDuration]);

  const playerContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((event) => {
      dispatch(SetPlayerHeight(event[0].borderBoxSize[0].blockSize));
      dispatch(SetPlayerResponsive(false));
    });

    if (playerContainer.current) resizeObserver.observe(playerContainer.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [playerContainer.current]);

  const player = useMemo(() => {
    return (
      <ReactPlayerWrapper>
        {/* <Stack spacing={1}>
          <MediaPlayerMarkers
            timecodes={MapQCMarkerData(markers, frameDuration).filter((x) => x.timecodes.out.isSet)}
            sx={{ mt: 1.5 }}
          />
        </Stack> */}
      </ReactPlayerWrapper>
    );
  }, [markers, frameDuration]);

  const updateMetasCall = (objectId: number, metadataUpdates: IDbBaseMetadataValueInfos[]) => {
    assetService
      .UpdateMetadataFields(new UpdateMetadataFieldsRequest({ objectId: objectId, metadata: metadataUpdates }))
      .then((response) => {
        if (response.success) enqueueCustomSnackbar(t("alert:success.changesHasBeenSaved"), "success");
        else enqueueCustomSnackbar(t("alert:error.oopsWithMessage", { message: response.message }), "warning");
      });
  };

  // Methods
  const saveMetadata = useCallback(async () => {
    if (metadataUpdates.length === 0 || !metadataUpdatesValid) {
      console.warn("SaveMetadata() not ready!");
      enqueueCustomSnackbar(t("alert:warning.metadataNotReadyToBeSaved"), "warning");
      return;
    }

    if (obj?.classification === ObjectClass.Mezz && UserHasAcl(AclTypes.aclSuperUser)) {
      // Apply rules checker (for now only for super & internal users)
      const checkResponse = await assetService.CheckUpdateMetadataFields({ objectId: id, metadata: metadataUpdates });

      if (checkResponse.success) {
        updateMetasCall(id, metadataUpdates);
      } else {
        openModal &&
          openModal<ModalCheckUpdateMetadataFieldsElementProps>(ModalCheckUpdateMetadataFields, {
            checkUpdateResponse: checkResponse,
            onOverrideCheck: () => {
              updateMetasCall(id, metadataUpdates);
            },
          });
      }
    } else {
      updateMetasCall(id, metadataUpdates);
    }
  }, [id, obj, metadataUpdates, metadataUpdatesValid]);

  // Handlers
  const handleSave = useCallback(() => {
    if (!qcData) saveMetadata();
    else {
      if (!openModal) return;
      openModal<ModalCompleteUserTaskElementProps>(ModalCompleteUserTask, {
        task: qcData.task,
        workflowId: qcData.workflowInstanceId,
        onClose: (success: boolean) => {
          saveMetadata();
        },
      });
    }
  }, [id, qcData, metadataUpdates, metadataUpdatesValid]);

  const handleGoAsset = useCallback(() => {
    navigate(`${routePaths.asset.path}/${id}`);
  }, [id]);

  const handleGoAssetRef = useCallback(() => {
    OpenLinkInNewTab(`${routePaths.asset.path}/${refVideoAssetId}`);
  }, [refVideoAssetId]);

  const handleUnlinkSwitch = () => {
    setLinkedToSwitch(false);
    dispatch(SetPlayerInput({ objectId: id, episode: null, shareMediaKey: null }));
    if (tabValue === 4) setTabValue(1);
  };
  const handleLinkSwitch = () => {
    setLinkedToSwitch(true);
  };

  const handleLinkPremierePro = useCallback(() => {
    // TODO
  }, []);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleMarkerEdit = useCallback(
    (marker: DbAssetMarkerInfos) => {
      openModal &&
        openModal<ModalMarkerCreateOrEditProps>(ModalMarkerCreateOrEdit, {
          mode: "update",
          objectId: id,
          frameRate: frameRate,
          families: markerFamilies,
          types: markerTypes,
          marker: marker,
          tcFileIn: GetMetadataByTagName(obj!, "tcIn")?.value,
          onClose: (marker: DbAssetMarkerInfos) => {
            setMarkers(
              produce((draft) => {
                let index = draft.findIndex((x) => x.id === marker.id);
                if (index !== -1) draft[index] = marker;
              })
            );
          },
          closeModal: () => {},
        });
    },
    [id, obj, markerFamilies, markerTypes, frameRate]
  );

  const handleMarkerDelete = useCallback(
    (marker: DbAssetMarkerInfos) => {
      assetService.DeleteMarkerByMarkerId(marker.id).then((response) => {
        enqueueCustomSnackbar(t("alert:success.markerDeleted"), "success");

        setMarkers(
          produce((draft) => {
            let index = draft.findIndex((x) => x.id === marker.id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      });
    },
    [markers]
  );

  const handleMarkerRevision = useCallback(
    (markerId, newStatus: DbMarkerStatus, comment?: string) => {
      let checkedMarkerIndex = markers.findIndex((x) => x.id === markerId);

      if (checkedMarkerIndex !== -1) {
        let updatedMarkers = [...markers];
        updatedMarkers[checkedMarkerIndex] = {
          ...updatedMarkers[checkedMarkerIndex],
          commentReviewer: comment ?? null,
          status: newStatus,
        };

        setCheckedMarkers((prevState) => {
          const newState = [...prevState];
          const index = newState.findIndex((x) => x.id === markerId);
          if (index === -1) newState.push(updatedMarkers[checkedMarkerIndex]);
          else newState[index] = updatedMarkers[checkedMarkerIndex];
          return newState;
        });
      }
    },
    [markers, checkedMarkers]
  );

  const handleConfirmRevision = () => {
    let partialIds = checkedMarkers.map((obj) => obj.id);
    let missingObjects = markers.filter((obj) => !partialIds.includes(obj.id));
    let updatedPartialObjects = [...checkedMarkers, ...missingObjects];

    let request: AddOrUpdateMarkersByObjectIdRequest = {
      objectId: id,
      markers: updatedPartialObjects,
      sendNotification: true,
      checkedMarkerIds: checkedMarkers.map((item) => item.id),
    };

    assetService.AddOrUpdateMarkersByObjectId(request).then((response) => {
      if (response && response.success) {
        enqueueCustomSnackbar(t("alert:success.markersUpdated"), "success");
        setCheckedMarkers([]);
        setMarkers(updatedPartialObjects);
      }
    });
  };

  const handleClaimWorkflowUserTask = useCallback(() => {
    workflowService.ClaimUserTask(qcData?.workflowInstanceId!).then((response) => {
      if (response.success) {
        enqueueCustomSnackbar(t("alert:success.claimedWorkflowUserTask"), "success");
        setQcData(
          produce((draft) => {
            if (draft) draft.isClaimedByUser = true;
          })
        );
      } else enqueueCustomSnackbar(t("alert:error.tryingClaimTask"), "warning");
    });
  }, [qcData]);

  const handleMetadataChange = (valid: boolean, metadata: IDbBaseMetadataValueInfos[]) => {
    setMetadataUpdatesValid(valid);
    setMetadataUpdates(metadata);

    console.debug("ME change valid = [" + valid + "] for field count = [" + metadata.length + "]");
  };

  const handleGenerateThumbs = useCallback(() => {
    thumbnailService.GenerateMarkerThumbnailsByObjectId(id).then((response) => {
      if (response.success)
        enqueueCustomSnackbar(response.message ?? t("alert:success.thumbsWillBeGenerated"), "success");
      else enqueueCustomSnackbar(t("alert:warning.requestingThumbnailsGeneration"), "warning");
    });
  }, [markers, id]);

  const handleAudioTracksChange = useCallback(
    (metadata: IDbBaseMetadataValueInfos) => {
      assetService.GetObjectLightById(id).then((response) => {
        if (response && response.graph) setObject(response.graph);
      });

      console.debug("Audio tracks changed");
    },
    [obj, id]
  );

  // Main loader
  useEffect(() => {
    if (id === -1) {
      navigate(routePaths.inventory.path);
      return;
    }
    // Fetch object and make player
    assetService.GetObjectLightById(id).then((response) => {
      if (response && response.graph) {
        dispatch(SetPlayerInput({ objectId: id, episode: null, shareMediaKey: null }));

        setObject(response.graph);
        setIsAdamTrailer(
          platformMode === PlatformMode.Adam &&
            (GetMetadataByTagName(response.graph!, "adamAssetType")?.value === "trailer" || false)
        );
        setObjectType(response.graph.type);
        setObjectFullName(
          `${response.graph.parentTitleName ? response.graph.parentTitleName + " - " : ""}${response.graph.name}`
        );

        // Fetch workflow/claim data
        if (UserHasAcls([AclTypes.aclAdmin, AclTypes.aclSuperUser], AclMatch.OneAtLeast)) {
          if (response.graph.status === ObjectStatus.ToBeQCed) {
            workflowService.GetUserTasksForAssetSingle(id).then((response) => {
              setQcData(response);
            });
          }
        }

        // Load main title to get video reference
        if (response.graph.parentTitleId) {
          assetService.GetGraph(response.graph.parentTitleId, true, true, false).then((responseTitle) => {
            if (responseTitle.success && responseTitle.graph) {
              // Fetch ref video
              //let refContentId = responseTitle.graph.metadata?.find((x) => x.fieldName === "referenceContentId")?.value;
              let refContentId = response.graph?.parentObjectId;
              if (refContentId) {
                let refContent = responseTitle.graph.childObjects?.find((x) => x.id === refContentId);

                if (refContent) {
                  let refs = refContent.metadata?.find((x) => x.fieldName === "refVideoAssetIds")?.value;

                  if (refs) {
                    if (GetMetadataByTagName(responseTitle.graph, "titleType")?.value === "Season") {
                      let currentEpNb = GetMetadataByTagName(response.graph, "serieEpisodeNumberProduction")?.value;
                      let asset = refContent.childObjects?.find(
                        (x) =>
                          refs.includes(x.id) &&
                          GetMetadataByTagName(x, "serieEpisodeNumberProduction")?.value === currentEpNb
                      );

                      if (asset) {
                        setRefVideoAssetId(asset.id);
                        console.debug("qctool: ref video asset Id = " + asset.id);
                      }
                    } else {
                      let asset = refContent.childObjects?.find((x) => x.id === refs[0]);

                      if (asset) {
                        setRefVideoAssetId(asset.id);
                        console.debug("qctool: ref video asset Id = " + asset.id);
                      }
                    }
                  }
                }
              }
            }
          });
        }

        setIsLoadingObj(false);
      }
    });

    // Fetch markers data
    assetService.GetMarkerEnums().then((response) => {
      response.families && setMarkerFamilies(response.families);
      response.types && setMarkerTypes(response.types);
    });

    // Fetch files
    mediaService.GetFilesByObjectId(id).then((response) => {
      if (response && response.files) setFiles(response.files);
    });
  }, [id]);

  useEffect(() => {
    if (!obj || !obj.id) return;

    // Fetch markers linked to object
    assetService.GetMarkersByObjectId(id).then((response) => {
      if (response && response.markers) {
        response.markers?.sort((a, b) => {
          return a.frameIn! - b.frameIn!;
        });
        const frDuration =
          response.timecodeOutFileFrames !== null && response.timecodeInFileFrames !== null
            ? response.timecodeOutFileFrames - response.timecodeInFileFrames
            : null;
        if (frDuration) SetFrameDuration(frDuration);
        const frRate = GetMetadataByTagName(obj, "techFrameRate")?.value ?? 0;
        setFrameRate(frRate);
        setMarkers(response.markers.map((x) => getMarkerWIthTC(x, frRate, frameDuration)));
        setIsLoadingMarkers(false);
      }
    });
  }, [obj?.id, id]);

  const handleOpenPdfModal = (objectId) => {
    if (!openModal) return;

    openModal<ModalDocumentPreviewElementProps>(ModalPreviewBatonPdf, {
      objectId: objectId,
    });
  };

  const userCanExportPdf = useMemo(() => UserHasAcl(AclTypes.aclAssetPdfExport), []);

  return (
    <FullTaskLayout
      TopBar={
        <FullTaskTopbar
          title={`${t("common:qcTool")} -> ${objectFullName}`}
          backRoute={`${routePaths.asset.path}/${id}`}
          rightContent={
            <>
              {qcData?.task && (
                <Button
                  variant="contained"
                  disabled={!qcData?.userHasRightToClaim}
                  startIcon={<LockOutlinedIcon />}
                  onClick={handleClaimWorkflowUserTask}
                >
                  {qcData?.isClaimedByUser ? qcData?.task.claimInfos?.userName ?? "You" : "Claim"}
                </Button>
              )}
              <Button
                variant="contained"
                color="primary"
                endIcon={<ArrowForwardIcon />}
                onClick={handleSave}
                disabled={isLoadingObj}
              >
                {t("button:saveChanges")}
              </Button>
            </>
          }
        />
      }
      sxWrapper={{ height: "100vh" }}
      sxStack={{ width: "100%" }}
    >
      <FullTaskSplit
        layout="1:3"
        sx={{
          p: 0.5,

          "&:before": {
            content: '""',
            position: "absolute",
            width: "30%",
            height: "60%",
            left: "-5%",
            top: "-5%",
            background: AssetTypeAlphaColor(objectType, 0.2),
            filter: " blur(106px)",
            transform: "rotate(20.23deg)",
            pointerEvents: "none",
          },
        }}
        sxContainer={{ display: "flex", justifyContent: "center", alignItems: "center", pt: 2, pb: 3 }}
      >
        <Stack
          alignItems="center"
          justifyContent="center"
          position="relative"
          width={"100%"}
          height={"100%"}
          pt={linkedToSwitch ? "0px" : "20px"}
          zIndex={1}
        >
          <Box
            overflow="auto"
            height="100%"
            display="flex"
            flexDirection="column"
            width={"100%"}
            ref={playerContainer}
            flexGrow={1}
            sx={{
              flewGrow: 1,
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            {linkedToSwitch ? <SwitchPlayerWrapper files={files} setSwitchData={setSwitchData} /> : player}
          </Box>
          <Typography mb={1} mt={3} variant="subtitle2" textAlign="center">
            {obj?.parentTitleName} - {obj?.name}
          </Typography>
          <Stack direction="row" alignItems="center" justifyContent="center" flexWrap="wrap" spacing={0.5}>
            <AssetTypeChip type={obj?.type ?? ObjectType.Unknown} />
            <AssetClassChip classification={obj?.classification ?? ObjectClass.Project} />
            {obj && <Chip label={GetMetadataByTagName(obj, "techCodec")?.value} />}
            {obj && <Chip label={t("chip:label.assetWithId", { id: obj.id })} />}
          </Stack>
        </Stack>
      </FullTaskSplit>
      <FullTaskSplit layout="1:3" sxContainer={{ maxWidth: "unset !important" }}>
        <Stack height="100%">
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} mb={3}>
            <Stack>
              <Typography variant="subtitle2" component="h2">
                {t("page:body.qualityCheckEditor")}
              </Typography>
              <Typography color="text.secondary" variant="body2" mt={0.5}>
                {t("page:body.inspectAndControlMedia")}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1}>
              {linkedToSwitch ? (
                <Button startIcon={<LinkOffIcon />} onClick={handleUnlinkSwitch}>
                  {t("button:unlinkTelestreamSwitch")}
                </Button>
              ) : (
                <Button
                  disabled={
                    !(
                      UserHasAcl(AclTypes.aclPlayTelestreamSwitch) &&
                      UserHasAcl(AclTypes.aclMakeTransferFileDownloadLink) &&
                      UserHasLicence(Licences.PlayTelestreamSwitch)
                    )
                  }
                  startIcon={<LinkIcon />}
                  onClick={handleLinkSwitch}
                >
                  {t("button:linkTelestreamSwitch")}
                </Button>
              )}
              {/* <Button startIcon={<LinkIcon />} disabled={true} onClick={handleLinkPremierePro}>
                Link to Adobe Premiere Pro
              </Button> */}
              <Button startIcon={<DownloadIcon />} onClick={() => handleOpenPdfModal(id)} disabled={!userCanExportPdf}>
                {t("common:exportBatonPdf")}
              </Button>
              <a
                href={`${routePaths.asset.path}/${id}`}
                onClick={(e) => {
                  // prevent handle click but keep mousewheel click.
                  e.preventDefault();
                }}
              >
                <Button startIcon={<ArrowBackIcon />} onClick={handleGoAsset} href={`${routePaths.asset.path}/${id}`}>
                  {t("button:goToAsset")}
                </Button>
              </a>
              {refVideoAssetId && (
                <a
                  href={`${routePaths.asset.path}/${refVideoAssetId}`}
                  onClick={(e) => {
                    // prevent handle click but keep mousewheel click.
                    e.preventDefault();
                  }}
                >
                  <Button startIcon={<ArrowForwardIcon />} onClick={handleGoAssetRef}>
                    {t("button:goToRefWithId", { id: refVideoAssetId })}
                  </Button>
                </a>
              )}
            </Stack>
          </Stack>

          {isLoadingObj && (
            <CircularProgress
              sx={{
                position: "relative",
                top: "44%",
                left: "50%",
              }}
            />
          )}

          {!isLoadingObj && (
            <>
              <StyledTabs variant="fullWidth" value={tabValue} onChange={handleTabChange}>
                {isAdamTrailer && <Tab label={t("page:tab.label.validation")} {...a11yProps(0)} />}
                <Tab label={t("page:tab.label.Markers")} {...a11yProps(isAdamTrailer ? 1 : 0)} />
                <Tab label={t("common:metadata")} {...a11yProps(isAdamTrailer ? 2 : 1)} />
                <Tab label={t("page:tab.label.audioTracks")} {...a11yProps(isAdamTrailer ? 3 : 2)} />
                <Tab label={t("common:mediaFiles")} {...a11yProps(isAdamTrailer ? 4 : 3)} />
                {linkedToSwitch && (
                  <Tab label={t("page:tab.label.switchMetadata")} {...a11yProps(isAdamTrailer ? 5 : 4)} />
                )}
              </StyledTabs>

              <Stack mt={3} sx={{ flex: "1 1 0", minHeight: 0 }}>
                {isAdamTrailer && (
                  <PanelTabContent index={0} activePanelIndex={tabValue} id="asset-details-panel">
                    <AssetHeroAdamCard
                      sx={{ mb: 1.5 }}
                      asset={assetService.GetAdminAssetSingleDtoFromAssetObject(obj!)}
                      setAssetData={setObject}
                    />
                  </PanelTabContent>
                )}
                <PanelTabContent index={isAdamTrailer ? 1 : 0} activePanelIndex={tabValue} id="asset-details-panel">
                  <Stack direction="row" justifyContent="space-between" mb={3}>
                    <Stack direction="row" spacing={1}>
                      <Select
                        startAdornment={<ListIcon />}
                        IconComponent={ExpandMoreRoundedIcon}
                        value={filterMarkerCategory}
                        inputProps={{ "aria-label": "Without label" }}
                        MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
                        fullWidth
                        displayEmpty
                        onChange={(e) => {
                          setFilterMarkerCategory(e.target.value as DbMarkerCategory);
                        }}
                      >
                        <MenuItem value={undefined}>{t("common:category")}</MenuItem>
                        {Object.keys(DbMarkerCategory).map((value) => (
                          <MenuItem key={value} value={DbMarkerCategory[value]}>
                            {DbMarkerCategory[value]}
                          </MenuItem>
                        ))}
                      </Select>

                      <Select
                        startAdornment={<ListIcon />}
                        IconComponent={ExpandMoreRoundedIcon}
                        multiple
                        value={filterMarkerFamilies}
                        inputProps={{ "aria-label": "Without label" }}
                        MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
                        fullWidth
                        displayEmpty
                        onChange={(v) => {
                          if (!v) setFilterMarkerFamilies([]);
                          else setFilterMarkerFamilies(v.target.value as string[]);
                        }}
                        renderValue={(v) => (!v || v.length === 0 ? "Family" : v.join(", "))}
                      >
                        {markerFamilies.map((value) => (
                          <MenuItem key={value.name} value={value.name}>
                            {value.name}
                          </MenuItem>
                        ))}
                      </Select>

                      <Select
                        startAdornment={<ListIcon />}
                        IconComponent={ExpandMoreRoundedIcon}
                        value={filterMarkerSeverity}
                        inputProps={{ "aria-label": "Without label" }}
                        MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
                        fullWidth
                        displayEmpty
                        onChange={(e) => {
                          setFilterMarkerSeverity(e.target.value as DbMarkerSeverity);
                        }}
                      >
                        <MenuItem value={undefined}>{t("common:severity")}</MenuItem>
                        {Object.keys(DbMarkerSeverity).map((value) => (
                          <MenuItem key={value} value={DbMarkerSeverity[value]}>
                            {DbMarkerSeverity[value]}
                          </MenuItem>
                        ))}
                      </Select>

                      <Select
                        startAdornment={<ListIcon />}
                        IconComponent={ExpandMoreRoundedIcon}
                        value={filterMarkerLevel}
                        inputProps={{ "aria-label": "Without label" }}
                        MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
                        fullWidth
                        displayEmpty
                        onChange={(e) => {
                          setFilterMarkerLevel(e.target.value as DbMarkerLevel);
                        }}
                      >
                        <MenuItem value={undefined}>{t("common:level")}</MenuItem>
                        {Object.keys(DbMarkerLevel).map((value) => (
                          <MenuItem key={value} value={DbMarkerLevel[value]}>
                            {DbMarkerLevel[value]}
                          </MenuItem>
                        ))}
                      </Select>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Button
                        disabled={markers.length > 0 && checkedMarkers.length < 1}
                        onClick={handleSendReviewNotif}
                      >
                        {t("button:submitRevision")}
                      </Button>
                      {UserHasAcl(AclTypes.aclMarkerCreateOrUpdate) && (
                        <Button startIcon={<AddIcon />} onClick={openNewMarkerModal}>
                          {t("button:newMarkerShortcut")}
                        </Button>
                      )}
                      {markers.filter(
                        (x) =>
                          x.frameIn !== null &&
                          x.frameIn !== 0 &&
                          (x.thumbnailIn === null || x.thumbnailIn.$value === null)
                      ).length > 0 &&
                        UserHasAcl(AclTypes.aclMarkerCreateOrUpdate) && (
                          <Button startIcon={<ImageIcon />} onClick={handleGenerateThumbs}>
                            {t("button:generateThumbs")}
                          </Button>
                        )}
                    </Stack>
                  </Stack>
                  {!isLoadingMarkers && (
                    <MarkersTable
                      objectId={id}
                      markers={markers.filter(
                        (x) =>
                          (!filterMarkerSeverity || x.severity === filterMarkerSeverity) &&
                          (!filterMarkerCategory || x.category === filterMarkerCategory) &&
                          (!filterMarkerLevel || x.level === filterMarkerLevel) &&
                          (filterMarkerFamilies.length === 0 || filterMarkerFamilies.includes(x.familyInfos?.name!))
                      )}
                      playerSeekEnable
                      onMarkerRowClick={handleMarkerEdit}
                      onMarkerDelete={handleMarkerDelete}
                      onMarkerRevision={handleMarkerRevision}
                      columnVisibilityModel={{ commentReviewer: false }}
                    />
                  )}
                  {isLoadingMarkers && <TableSkeleton />}
                </PanelTabContent>
                <PanelTabContent index={isAdamTrailer ? 2 : 1} activePanelIndex={tabValue} id="asset-details-panel">
                  <MetadataEditor
                    objectIds={[id]}
                    objectType={obj?.type}
                    viewType={MetadataViewType.QcTool}
                    onMetadataChange={handleMetadataChange}
                  />
                </PanelTabContent>
                <PanelTabContent index={isAdamTrailer ? 3 : 2} activePanelIndex={tabValue} id="asset-details-panel">
                  {obj && (
                    <>
                      {cacheService.GetPlatformMode() === PlatformMode.Adam ||
                      cacheService.GetUserInfo()?.prefs?.audioTracksList ||
                      cacheService.GetPlatformSettings()?.prefsDefault?.audioTracksList ? (
                        <AudioTracksList asset={obj} />
                      ) : (
                        <AudioTracksExcel asset={obj} />
                      )}
                    </>
                  )}

                  <Alert color="warning" sx={{ mt: 1 }}>
                    {t("alert:warning.audioTracksSaveReminder")}
                  </Alert>
                </PanelTabContent>
                <PanelTabContent index={isAdamTrailer ? 4 : 3} activePanelIndex={tabValue} id="asset-details-panel">
                  <Grid container spacing={1}>
                    {files.map((file, index) => (
                      <Grid item md={6} key={index}>
                        <MediaCard
                          key={index}
                          fileId={file.id}
                          isDownloable={false}
                          title={file.name!}
                          type={obj!.type}
                          status={file.status!}
                          duration={(file.properties.duration?.timecode as string) || "-"}
                          storageLocation={file.storageInfos?.name ?? ""}
                          category={file.category!}
                          accessibility={file.accessibility!}
                          size={GetFileSize(file.sizeInBytes!) ?? ""}
                          date={
                            file.creationInfos?.date
                              ? moment(file.creationInfos?.date).format(GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS)
                              : "Unknown"
                          }
                          hideRequestDownloadLink
                        />
                      </Grid>
                    ))}
                  </Grid>
                </PanelTabContent>
                {linkedToSwitch && (
                  <PanelTabContent
                    index={isAdamTrailer ? 5 : 4}
                    activePanelIndex={tabValue}
                    id="telestream-switch-metadata"
                  >
                    <Stack mt={-1} display={"flex"} direction={"column"} spacing={2}>
                      {switchData.containerProps && (
                        <FormSection
                          size="small"
                          defaultExpanded={true}
                          title={t("form:section.title.containerProperties")}
                        >
                          <Grid container rowSpacing={1} columnSpacing={3}>
                            {Object.keys(switchData.containerProps)
                              .filter(
                                (x) =>
                                  typeof switchData.containerProps[x] === "string" ||
                                  typeof switchData.containerProps[x] === "number" ||
                                  typeof switchData.containerProps[x] === "boolean"
                              )
                              .map((x, i) => (
                                <Grid
                                  key={i}
                                  sx={{ display: "flex", justifyContent: "space-between" }}
                                  item
                                  md={6}
                                  sm={12}
                                  xs={12}
                                >
                                  <Typography variant="body2" color="text.secondary" flexShrink={0}>
                                    {x
                                      .split(" ")
                                      .map((w) => w[0].toUpperCase() + w.slice(1))
                                      .join(" ")}
                                  </Typography>
                                  <Typography variant="body2">{switchData.containerProps[x]}</Typography>
                                </Grid>
                              ))}
                          </Grid>
                        </FormSection>
                      )}
                      {switchData.videoProps && (
                        <FormSection
                          size="small"
                          defaultExpanded={true}
                          title={t("form:section.title.videoProperties")}
                        >
                          <Grid container rowSpacing={1} columnSpacing={3}>
                            {Object.keys(switchData.videoProps)
                              .filter(
                                (x) =>
                                  typeof switchData.videoProps[x] === "string" ||
                                  typeof switchData.videoProps[x] === "number" ||
                                  typeof switchData.videoProps[x] === "boolean"
                              )
                              .map((x, i) => (
                                <Grid
                                  key={i}
                                  sx={{ display: "flex", justifyContent: "space-between" }}
                                  item
                                  md={6}
                                  sm={12}
                                  xs={12}
                                >
                                  <Typography variant="body2" color="text.secondary" flexShrink={0}>
                                    {x
                                      .split(" ")
                                      .map((w) => w[0].toUpperCase() + w.slice(1))
                                      .join(" ")}
                                  </Typography>
                                  <Typography variant="body2">{switchData.videoProps[x]}</Typography>
                                </Grid>
                              ))}
                          </Grid>
                          {switchData.videoProps?.metadata && (
                            <FormSection
                              sx={{ mt: 2 }}
                              size="small"
                              title={t("form:section.title.videoMetadata")}
                              defaultExpanded={false}
                            >
                              <Grid container rowSpacing={1} columnSpacing={3}>
                                {Object.keys(switchData.videoProps.metadata).map((x, i) => (
                                  <Grid
                                    key={i}
                                    sx={{ display: "flex", justifyContent: "space-between" }}
                                    item
                                    md={6}
                                    sm={12}
                                    xs={12}
                                  >
                                    <Typography variant="body2" color="text.secondary" flexShrink={0}>
                                      {x
                                        .split(" ")
                                        .map((w) => w[0].toUpperCase() + w.slice(1))
                                        .join(" ")}
                                    </Typography>
                                    <Typography variant="body2">{switchData.videoProps.metadata[x]}</Typography>
                                  </Grid>
                                ))}
                              </Grid>
                            </FormSection>
                          )}
                        </FormSection>
                      )}
                      {switchData.audioProps && (
                        <FormSection
                          size="small"
                          defaultExpanded={true}
                          title={t("form:section.title.audioProperties")}
                        >
                          {switchData.audioProps.map((audioProps, i) => (
                            <FormSection
                              key={i}
                              sx={{ mt: i > 0 ? 2 : 0 }}
                              size="small"
                              defaultExpanded={false}
                              title={t("audioTrack.propertiesTitle", { index: i + 1 })}
                            >
                              <Grid mt={2} container rowSpacing={1} columnSpacing={3}>
                                {audioProps &&
                                  Object.keys(audioProps)
                                    .filter(
                                      (x) =>
                                        typeof audioProps[x] === "string" ||
                                        typeof audioProps[x] === "number" ||
                                        typeof audioProps[x] === "boolean"
                                    )
                                    .map((x, n) => (
                                      <Grid
                                        sx={{ display: "flex", justifyContent: "space-between" }}
                                        item
                                        key={n}
                                        md={6}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Typography variant="body2" color="text.secondary" flexShrink={0}>
                                          {x
                                            .split(" ")
                                            .map((w) => w[0].toUpperCase() + w.slice(1))
                                            .join(" ")}
                                        </Typography>
                                        <Typography variant="body2">{audioProps[x]}</Typography>
                                      </Grid>
                                    ))}
                              </Grid>
                            </FormSection>
                          ))}
                        </FormSection>
                      )}
                      {switchData.subtitleProps && (
                        <FormSection
                          size="small"
                          defaultExpanded={true}
                          title={t("form:section.title.subtitleProperties")}
                        >
                          <Grid container rowSpacing={1} columnSpacing={3}>
                            {Object.keys(switchData.subtitleProps)
                              .filter(
                                (x) =>
                                  typeof switchData.subtitleProps[x] === "string" ||
                                  typeof switchData.subtitleProps[x] === "number" ||
                                  typeof switchData.subtitleProps[x] === "boolean"
                              )
                              .map((x, i) => (
                                <Grid
                                  key={i}
                                  sx={{ display: "flex", justifyContent: "space-between" }}
                                  item
                                  md={6}
                                  sm={12}
                                  xs={12}
                                >
                                  <Typography variant="body2" color="text.secondary" flexShrink={0}>
                                    {x
                                      .split(" ")
                                      .map((w) => w[0].toUpperCase() + w.slice(1))
                                      .join(" ")}
                                  </Typography>
                                  <Typography variant="body2">{switchData.subtitleProps[x]}</Typography>
                                </Grid>
                              ))}
                          </Grid>
                        </FormSection>
                      )}
                    </Stack>
                  </PanelTabContent>
                )}
              </Stack>
            </>
          )}
        </Stack>
      </FullTaskSplit>
    </FullTaskLayout>
  );
};

export default QcTool;

const StyledBox = styled(Box, { shouldForwardProp: (prop) => prop !== "assetType" })<{ assetType: ObjectType }>(
  ({ assetType }) => ({
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 12,
    width: 220,
    height: 220,
    background: AssetTypeAlphaColor(assetType, 0.1),
    overflow: "hidden",
    boxShadow: "0px 24px 32px rgba(22, 16, 15, 0.38)",
    "&:before, &:after": {
      position: "absolute",
      content: '""',
      filter: " blur(84px)",
    },
    "&:before": {
      width: 212,
      height: 212,
      left: -130,
      top: 94,
      background: "#110700",
      filter: " blur(84px)",
    },
    "&:after": {
      width: 170,
      height: 170,
      left: 120,
      top: -95,
      background: AssetTypeAlphaColor(assetType, 0.1),
    },

    ".MuiChip-root": {
      position: "absolute",
      top: 12,
      left: 12,
    },
  })
);

const StyledTabs = styled(Tabs)(({ theme }) => ({
  background: theme.palette.background.default,
  borderRadius: 10,
  padding: 0,
  margin: 0,
}));

function a11yProps(index: number) {
  return {
    id: `asset-details-panel-tab-${index}`,
    "aria-controls": `asset-details-panel-tabpanel-${index}`,
  };
}
